// mobile_v1: responsive — 2x2 cards + license stack + smaller fonts บน mobile
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; /* dashboard_renew_button_v1 */
import API from '../api';
import { MessageSquare, CheckCircle, Clock, Bot } from 'lucide-react';
import QuotaDashboard from '../components/QuotaDashboard'; // quota_v1

const Card = ({ icon: Icon, label, value, color, isMobile }) => (
  <div style={{
    background: '#1e293b',
    borderRadius: 12,
    padding: isMobile ? '14px 14px' : 24,
    display: 'flex',
    alignItems: 'center',
    gap: isMobile ? 10 : 16,
    minWidth: 0,
  }}>
    <div style={{
      background: color + '20',
      borderRadius: 10,
      padding: isMobile ? 8 : 12,
      flexShrink: 0,
    }}>
      <Icon size={isMobile ? 18 : 24} color={color} />
    </div>
    <div style={{ minWidth: 0, flex: 1 }}>
      <p style={{
        color: '#94a3b8',
        fontSize: isMobile ? 11 : 13,
        margin: 0,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}>{label}</p>
      <p style={{
        color: '#f1f5f9',
        fontSize: isMobile ? 22 : 28,
        fontWeight: 700,
        margin: 0,
        lineHeight: 1.1,
        marginTop: 2,
      }}>{value}</p>
    </div>
  </div>
);

/* customer_report_v1 helpers */
const _todayStr = () => new Date().toISOString().split('T')[0];
const _daysAgoStr = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return d.toISOString().split('T')[0]; };
/* customer_report_trend_v1 */
const _trend = (cur, prev, hib) => {
  const c = Number(cur) || 0, p = Number(prev) || 0;
  if (c === 0 && p === 0) return null;
  if (c === p) return { text: '±0', good: true };
  const chg = p > 0 ? Math.round(Math.abs(c - p) / p * 100) : 100;
  const up = c > p;
  return { text: (up ? '▲ ' : '▼ ') + chg + '%', good: hib ? up : !up };
};

export default function Dashboard() {
  const [kpi, setKpi] = useState(null);
  const [license, setLicense] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const tenant = JSON.parse(localStorage.getItem('tenant') || '{}');
  /* customer_report_v1 */
  const [cr, setCr] = useState(null);
  const [crFrom, setCrFrom] = useState(_daysAgoStr(29));
  const [crTo, setCrTo] = useState(_todayStr());
  const loadCR = (f, t) => {
    const _f = f || crFrom, _t = t || crTo;
    API.get('/api/customers/report?from=' + _f + '&to=' + _t).then(r => setCr(r.data)).catch(() => {});
  };
  useEffect(() => { loadCR(); /* eslint-disable-next-line */ }, []);
  const crPreset = (n, monthMode) => {
    const t = new Date(); const to = t.toISOString().split('T')[0];
    let from;
    if (monthMode) from = new Date(t.getFullYear(), t.getMonth(), 1).toISOString().split('T')[0];
    else { const d = new Date(t); d.setDate(d.getDate() - (n - 1)); from = d.toISOString().split('T')[0]; }
    setCrFrom(from); setCrTo(to); loadCR(from, to);
  };

  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);

  useEffect(() => {
    API.get('/api/kpi').then(r => setKpi(r.data)).catch(() => {});
    API.get('/api/tenants/me').then(r => setLicense(r.data.license)).catch(() => {});
  }, []);

  /* dashboard_renew_button_v1: navigate hook for renew button */
  const navigate = useNavigate();

  // expiry_bkk_v1: คำนวณ daysLeft โดยเทียบ end-of-day BKK
  const daysLeft = license ? (() => {
    const exp = new Date(license.expires_at);
    const todayBkkStr = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Bangkok', year: 'numeric', month: '2-digit', day: '2-digit'
    }).format(new Date());
    const todayEnd = new Date(todayBkkStr + 'T16:59:59.999Z');
    return Math.ceil((exp - todayEnd) / 86400000);
  })() : null;
  const isLowLicense = daysLeft !== null && daysLeft <= 7;

  return (
    <div style={{ padding: isMobile ? '16px 12px' : 0 }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: isMobile ? 16 : 24,
        flexWrap: 'wrap',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? 12 : 12,
      }}>
        <div style={{ width: isMobile ? '100%' : 'auto' }}>
          <h2 style={{
            fontSize: isMobile ? 18 : 22,
            fontWeight: 700,
            marginBottom: 4,
            marginTop: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}>👋 สวัสดี, {tenant.name}</h2>
          <p style={{
            color: '#94a3b8',
            fontSize: isMobile ? 12 : 14,
            margin: 0,
          }}>ภาพรวมระบบ 30 วันล่าสุด</p>
        </div>
        {license && (
          <div style={{
            background: isLowLicense ? '#fef2f2' : '#f0fdf4',
            border: `1px solid ${isLowLicense ? '#fecaca' : '#bbf7d0'}`,
            borderRadius: 10,
            padding: isMobile ? '10px 14px' : '10px 20px',
            textAlign: isMobile ? 'left' : 'center',
            width: isMobile ? '100%' : 'auto',
            boxSizing: 'border-box',
            display: isMobile ? 'flex' : 'block',
            alignItems: isMobile ? 'center' : 'initial',
            gap: isMobile ? 12 : 0,
          }}>
            <div style={{
              fontSize: isMobile ? 22 : 'inherit',
              flexShrink: 0,
            }}>
              {isMobile && (isLowLicense ? '⚠️' : '✅')}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{
                fontSize: 13,
                color: isLowLicense ? '#ef4444' : '#22c55e',
                fontWeight: 600,
              }}>
                {!isMobile && (isLowLicense ? '⚠️ ' : '✅ ')}License: <strong>{license.plan?.toUpperCase()}</strong>
              </div>
              <div style={{
                fontSize: isMobile ? 11 : 12,
                color: '#64748b',
                marginTop: 2,
              }}>
                หมดอายุ: {new Date(license.expires_at).toLocaleDateString('th-TH', { timeZone: 'Asia/Bangkok' })} ({daysLeft > 0 ? `เหลือ ${daysLeft} วัน` : 'หมดอายุแล้ว'})
              </div>
              {/* dashboard_renew_button_v1: renew button */}
              <button
                onClick={() => navigate('/renew')}
                style={{
                  marginTop: 8,
                  background: isLowLicense ? '#ef4444' : '#0ea5e9',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 6,
                  padding: isMobile ? '6px 12px' : '6px 14px',
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 4,
                  width: isMobile ? '100%' : 'auto',
                  justifyContent: 'center',
                  transition: 'opacity 0.15s',
                  opacity: isLowLicense ? 1 : 0.9,
                }}
                onMouseEnter={e => e.currentTarget.style.opacity = '1'}
                onMouseLeave={e => e.currentTarget.style.opacity = isLowLicense ? '1' : '0.9'}
              >
                🔄 ต่ออายุ
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Quota — รับ wrap container ทำให้ scroll ได้ถ้าจำเป็น */}
      <div style={{
        marginBottom: isMobile ? 16 : 24,
        overflowX: isMobile ? 'auto' : 'visible',
        WebkitOverflowScrolling: 'touch',
      }}>
        <QuotaDashboard /> {/* quota_v1 */}
      </div>

      {/* Stats Cards — 2x2 grid บน mobile, 4 cols บน desktop */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
        gap: isMobile ? 10 : 16,
        marginBottom: isMobile ? 16 : 24,
      }}>
        <Card icon={MessageSquare} label="บทสนทนาทั้งหมด" value={kpi?.overview?.total || 0} color="#38bdf8" isMobile={isMobile} />
        <Card icon={CheckCircle} label="แก้ไขสำเร็จ" value={kpi?.overview?.resolved || 0} color="#22c55e" isMobile={isMobile} />
        <Card icon={Clock} label="รอดำเนินการ" value={kpi?.overview?.open || 0} color="#f59e0b" isMobile={isMobile} />
        <Card icon={Bot} label="AI จัดการ" value={kpi?.overview?.ai_handled || 0} color="#a855f7" isMobile={isMobile} />
      </div>

      {/* Resolve Rate */}
      <div style={{
        background: '#1e293b',
        borderRadius: 12,
        padding: isMobile ? 16 : 24,
      }}>
        <h3 style={{
          marginBottom: isMobile ? 12 : 16,
          marginTop: 0,
          fontWeight: 600,
          fontSize: isMobile ? 14 : 16,
          color: '#f1f5f9',
        }}>📊 อัตราสำเร็จ</h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 12 : 16 }}>
          <div style={{
            flex: 1,
            background: '#0f172a',
            borderRadius: 8,
            height: isMobile ? 10 : 12,
          }}>
            <div style={{
              width: `${kpi?.overview?.resolve_rate || 0}%`,
              background: '#22c55e',
              height: '100%',
              borderRadius: 8,
              transition: 'width 1s',
            }} />
          </div>
          <span style={{
            color: '#22c55e',
            fontWeight: 700,
            fontSize: isMobile ? 16 : 18,
            flexShrink: 0,
          }}>{kpi?.overview?.resolve_rate || 0}%</span>
        </div>
      </div>
      {/* customer_report_v1: customer new/returning by business */}
      <div style={{ marginTop: 24 }}>
        <div style={{ display:'flex', flexWrap:'wrap', justifyContent:'space-between', alignItems:'center', gap:12, marginBottom:14 }}>
          <h3 style={{ margin:0, fontSize:18, fontWeight:700, color:'#1e293b', display:'flex', alignItems:'center', gap:8 }}>👥 รายงานลูกค้า</h3>
          <div style={{ display:'flex', gap:6, flexWrap:'wrap', alignItems:'center' }}>
            {/* customer_datepicker_v1: custom date range */}
            <input type="date" value={crFrom} max={crTo} onChange={e=>setCrFrom(e.target.value)} style={{ border:'1px solid #e2e8f0', borderRadius:8, padding:'6px 10px', fontSize:12.5, color:'#334155', background:'#fff' }} />
            <span style={{ color:'#94a3b8', fontSize:13 }}>—</span>
            <input type="date" value={crTo} min={crFrom} max={_todayStr()} onChange={e=>setCrTo(e.target.value)} style={{ border:'1px solid #e2e8f0', borderRadius:8, padding:'6px 10px', fontSize:12.5, color:'#334155', background:'#fff' }} />
            <button onClick={()=>loadCR()} style={{ background:'#0ea5e9', color:'#fff', border:'none', borderRadius:8, padding:'6px 14px', fontSize:12.5, fontWeight:700, cursor:'pointer' }}>ดู</button>
            {[['7 วัน',()=>crPreset(7)],['30 วัน',()=>crPreset(30)],['เดือนนี้',()=>crPreset(0,true)]].map((p)=>(
              <button key={p[0]} onClick={p[1]} style={{ background:'#f1f5f9', color:'#475569', border:'none', borderRadius:8, padding:'6px 12px', fontSize:12.5, fontWeight:600, cursor:'pointer' }}>{p[0]}</button>
            ))}
          </div>
        </div>
        {cr && cr.trend && cr.summary && (
          <div style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:12, padding:'12px 18px', marginBottom:16, display:'flex', flexWrap:'wrap', gap:'8px 22px', alignItems:'center' }}>
            {/* customer_trend_banner_v1 */}
            <span style={{ fontSize:13, fontWeight:700, color:'#475569' }}>📊 เทียบช่วงก่อนหน้า:</span>
            {[['ลูกค้าใหม่', cr.summary.new, cr.trend.new],['ลูกค้าเก่า', cr.summary.returning, cr.trend.returning],['รวมทั้งหมด', cr.summary.active, cr.trend.active]].map((x,i)=>{
              const c=Number(x[1])||0, p=Number(x[2])||0, up=c>p, same=c===p;
              const chg = p>0?Math.round(Math.abs(c-p)/p*100):(c>0?100:0);
              const col = same?'#94a3b8':(up?'#16a34a':'#dc2626');
              return (
                <span key={i} style={{ fontSize:13.5, color:'#334155' }}>
                  {x[0]} <b style={{ color:col }}>{same?'เท่าเดิม':(up?'▲ เพิ่มขึ้น ':'▼ ลดลง ')+chg+'%'}</b>
                </span>
              );
            })}
          </div>
        )}
        {cr && cr.summary && (
          <>
            <div style={{ display:'grid', gridTemplateColumns: isMobile?'repeat(2,1fr)':'repeat(4,1fr)', gap:12, marginBottom:16 }}>
              {[['👥 ลูกค้าที่ใช้งาน', cr.summary.active, '#0ea5e9', null, cr.trend?_trend(cr.summary.active, cr.trend.active, true):null],
                ['🟢 ลูกค้าใหม่', cr.summary.new, '#22c55e', cr.summary.new_pct+'%', cr.trend?_trend(cr.summary.new, cr.trend.new, true):null],
                ['🟣 ลูกค้าเก่า (กลับมา)', cr.summary.returning, '#6366f1', cr.summary.returning_pct+'%', cr.trend?_trend(cr.summary.returning, cr.trend.returning, true):null],
                ['🔁 อัตรากลับมา', cr.summary.retention_pct+'%', '#f59e0b', null, null]].map((c,i)=>(
                <div key={i} style={{ background:'#fff', borderRadius:14, padding:'16px 18px', boxShadow:'0 1px 6px rgba(0,0,0,0.07)', borderLeft:'4px solid '+c[2] }}>
                  <div style={{ fontSize:12.5, color:'#64748b', fontWeight:600 }}>{c[0]}</div>
                  <div style={{ fontSize:28, fontWeight:800, color:'#1e293b', marginTop:4 }}>{typeof c[1]==='number'?Number(c[1]).toLocaleString():c[1]}{c[3] && <span style={{ fontSize:14, color:'#94a3b8', fontWeight:700 }}> · {c[3]}</span>}{c[4] && <span style={{ fontSize:12, fontWeight:800, marginLeft:8, padding:'2px 6px', borderRadius:999, verticalAlign:'middle', color:c[4].good?'#16a34a':'#dc2626', background:c[4].good?'#f0fdf4':'#fef2f2' }}>{c[4].text}</span>}</div>
                </div>
              ))}
            </div>
            {cr.daily && cr.daily.length>0 && (()=>{
              const maxV = Math.max(1, ...cr.daily.map(d=>d.new+d.returning));
              const np = cr.summary.new_pct;
              return (
                <div style={{ display:'grid', gridTemplateColumns: isMobile?'1fr':'1.6fr 1fr', gap:16, marginBottom:16 }}>
                <div style={{ background:'#fff', borderRadius:14, padding:'18px 20px', boxShadow:'0 1px 6px rgba(0,0,0,0.07)' }}>
                  <div style={{ fontSize:14, fontWeight:700, color:'#1e293b', marginBottom:12 }}>📈 ลูกค้าใหม่ vs เก่า รายวัน</div>
                  <div style={{ display:'flex', alignItems:'flex-end', gap:2, height:120 }}>
                    {cr.daily.map((d,i)=>{
                      const tot=d.new+d.returning; const h=tot/maxV*120; const nh= tot>0 ? d.new/tot*h : 0;
                      return (
                        <div key={i} title={d.d+': ใหม่ '+d.new+' / เก่า '+d.returning} style={{ flex:1, display:'flex', flexDirection:'column', justifyContent:'flex-end', height:'100%' }}>
                          <div style={{ height: nh+'px', background:'#22c55e', borderRadius:'2px 2px 0 0' }} />
                          <div style={{ height: (h-nh)+'px', background:'#6366f1' }} />
                        </div>
                      );
                    })}
                  </div>
                  <div style={{ display:'flex', gap:16, fontSize:12, color:'#475569', marginTop:10 }}>
                    <span><span style={{ display:'inline-block', width:10, height:10, borderRadius:3, background:'#22c55e', marginRight:6, verticalAlign:'middle' }} />ลูกค้าใหม่</span>
                    <span><span style={{ display:'inline-block', width:10, height:10, borderRadius:3, background:'#6366f1', marginRight:6, verticalAlign:'middle' }} />ลูกค้าเก่า</span>
                  </div>
                </div>
                <div style={{ background:'#fff', borderRadius:14, padding:'18px 20px', boxShadow:'0 1px 6px rgba(0,0,0,0.07)', display:'flex', flexDirection:'column', alignItems:'center' }}>
                  <div style={{ fontSize:14, fontWeight:700, color:'#1e293b', marginBottom:14, alignSelf:'flex-start' }}>🥧 สัดส่วนรวม</div>
                  <div style={{ width:130, height:130, borderRadius:'50%', background:'conic-gradient(#22c55e 0% '+np+'%, #6366f1 '+np+'% 100%)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <div style={{ width:84, height:84, borderRadius:'50%', background:'#fff', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center' }}>
                      <div style={{ fontSize:22, fontWeight:800, color:'#1e293b' }}>{Number(cr.summary.active).toLocaleString()}</div>
                      <div style={{ fontSize:10, color:'#94a3b8' }}>ใช้งาน</div>
                    </div>
                  </div>
                  <div style={{ marginTop:14, fontSize:12.5, color:'#475569', alignSelf:'flex-start' }}>
                    <div><span style={{display:'inline-block',width:10,height:10,borderRadius:3,background:'#22c55e',marginRight:6,verticalAlign:'middle'}} />ใหม่ {Number(cr.summary.new).toLocaleString()} ({cr.summary.new_pct}%)</div>
                    <div style={{marginTop:5}}><span style={{display:'inline-block',width:10,height:10,borderRadius:3,background:'#6366f1',marginRight:6,verticalAlign:'middle'}} />เก่า {Number(cr.summary.returning).toLocaleString()} ({cr.summary.returning_pct}%)</div>
                  </div>
                </div>
                </div>
              );
            })()}
            {cr.by_business && cr.by_business.length>0 && (
              <div style={{ background:'#fff', borderRadius:14, padding:'18px 20px', boxShadow:'0 1px 6px rgba(0,0,0,0.07)' }}>
                <div style={{ fontSize:14, fontWeight:700, color:'#1e293b', marginBottom:12 }}>🏢 แยกตามธุรกิจ (ช่องทาง)</div>
                <div style={{ overflowX:'auto' }}>
                  <table style={{ width:'100%', borderCollapse:'collapse' }}>
                    <thead><tr>
                      {['ธุรกิจ','ใช้งาน','ใหม่','เก่า','สัดส่วน ใหม่/เก่า','% ใหม่','แนวโน้ม'].map((h,i)=>(
                        <th key={i} style={{ textAlign: (i===0||i===4)?'left':'right', padding:'0 12px 10px', fontSize:11, color:'#94a3b8', fontWeight:700, whiteSpace:'nowrap' }}>{h}</th>
                      ))}
                    </tr></thead>
                    <tbody>
                      {cr.by_business.map((b,i)=>{
                        const np = b.active>0 ? Math.round(b.new/b.active*100) : 0;
                        const tr = cr.trend ? _trend(b.active, b.prev_active, true) : null;
                        return (
                          <tr key={i}>
                            <td style={{ padding:'11px 12px', borderTop:'1px solid #f1f5f9', fontSize:13, fontWeight:700, color:'#1e293b' }}>{b.name}</td>
                            <td style={{ padding:'11px 12px', borderTop:'1px solid #f1f5f9', fontSize:13, textAlign:'right', fontWeight:700 }}>{Number(b.active).toLocaleString()}</td>
                            <td style={{ padding:'11px 12px', borderTop:'1px solid #f1f5f9', fontSize:13, textAlign:'right', color:'#16a34a', fontWeight:700 }}>{Number(b.new).toLocaleString()}</td>
                            <td style={{ padding:'11px 12px', borderTop:'1px solid #f1f5f9', fontSize:13, textAlign:'right', color:'#6366f1', fontWeight:700 }}>{Number(b.returning).toLocaleString()}</td>
                            <td style={{ padding:'11px 12px', borderTop:'1px solid #f1f5f9' }}><div style={{ height:8, borderRadius:4, background:'#6366f1', overflow:'hidden', minWidth:110 }}><div style={{ height:'100%', width:np+'%', background:'#22c55e' }} /></div></td>
                            <td style={{ padding:'11px 12px', borderTop:'1px solid #f1f5f9', fontSize:12.5, textAlign:'right', color:'#64748b' }}>{np}%</td>
                            <td style={{ padding:'11px 12px', borderTop:'1px solid #f1f5f9', fontSize:12, textAlign:'right' }}>{tr ? <span style={{ fontWeight:800, color:tr.good?'#16a34a':'#dc2626' }}>{tr.text}</span> : <span style={{ color:'#cbd5e1' }}>–</span>}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </div>

    </div>
  );
}
